import React, { useEffect, useState } from 'react';
import './css/channelCard.scss';

import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { followSwitching } from '../../../../Store/actions/channelActions';
import {
  ACCESS_REQUESTED,
  CLICK_CARD,
  ON_FOLLOW_CLICK,
  ON_UNFOLLOW_CLICK
} from '../../../../TrackerFolder/constants/ActionType';
import {
  AccessRequested,
  onCardClick,
  onFollow,
  onUnFollow
} from '../../../../TrackerFolder/actions/UserActions';
import { BsPlusLg } from '../../../../components/icons';
import { useTracker } from '../../../../TrackerFolder/TrackerComponent';
import LazyImage from '../../../../components/CustomLibraries/LazyImage';
const ChannelCard = (props) => {
  const channelData = props.data;
  const id = props.data.type_id;
  const { trackActivityEvent } = useTracker();
  const navigate = useNavigate();
  const [btnval, setBtnVal] = useState('');
  const [showPlusBut, setShowPlusBut] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    if (channelData.followed_status == 0) {
      if (channelData.privacy_status == 1) {
        setBtnVal('Request Access');
        setShowPlusBut(false);
      } else {
        setBtnVal('Follow');
      }
    } else if (channelData.followed_status == 3) {
      setShowPlusBut(false);
      setBtnVal('Unfollow');
    } else {
      setShowPlusBut(false);
      setBtnVal('Access Requested');
    }
  }, []);

  console.log('Hello ChannelData', channelData);

  function followSwitch(id) {
    dispatch(
      followSwitching(id, (response) => {
        console.log('Switch', response.data);

        if (response.data == 3) {
          trackActivityEvent(ON_FOLLOW_CLICK, onFollow(id));
        } else if (response.data == 1) {
          trackActivityEvent(ACCESS_REQUESTED, AccessRequested(id));
        } else {
          trackActivityEvent(ON_UNFOLLOW_CLICK, onUnFollow(id));
        }

        if (channelData.privacy_status == '0' || channelData.privacy_status == '2') {
          if (response.data == 3) {
            setBtnVal('Unfollow');
          } else {
            setBtnVal('Follow');
          }
        } else {
          if (response.data == 1) {
            setBtnVal('Access Requested');
          } else {
            setBtnVal('Request Access');
          }
        }
      })
    );
  }

  function cardActivity(id, name) {
    trackActivityEvent(CLICK_CARD, onCardClick(id, 'ChannelCard'));
    console.log(name, id);
    navigate(`/ChannelProfile?channel_name=${name}&id=${id}`);
  }

  return (
    <div className="w-100 chnlCardV1  d-flex flex-column justify-content-center align-items-center">
      <div
        className="chnlCardV1Img rounded-circle cursorPointer overflow-hidden"
        onClick={() => cardActivity(channelData.type_id, channelData.slug)}
      >
        <LazyImage
          src={channelData?.logo}
          className="chnlCardProfile position-absolute gtm_cl_channelCard object-fit-cover"
          alt="channel profile image"
          logo
        />
      </div>
      <div
        className="w-100 text-center my-3"
        onClick={() => cardActivity(channelData.type_id, channelData.slug)}
      >
        <a href="javascript:void(0)" className="text-black fs-16 gtm_cl_channelCard">
          {channelData?.title}
        </a>
      </div>
      <div className="w-100 d-flex justify-content-center mb-3">
        <a
          href="javascript:void(0)"
          className="rippleEffect btn btn-secondary fs-4 fw-medium rounded gtm_cl_channelCard_follow_unfollow d-flex align-items-center gap-2 p-4"
          onClick={() => followSwitch(id)}
        >
          {/* <span className="rippleEffect cmnBtn fs-4 fw-medium rounded gtm_cl_channelCard_follow_unfollow "> */}
          {showPlusBut ? (
            <BsPlusLg customClass="fs-4 m-1" gtmTagVariable="gtm_cl_channelCard_follow_unfollow" />
          ) : null}
          {btnval} {/* </span> */}
        </a>
      </div>
    </div>
  );
};

export default ChannelCard;
